import { IRoomControl } from "@pages/Assets/Room/DetailView/RoomControl";
import { Account } from "@services/account/types";
import { DeviceModelDetail } from "@services/catalog/types";
import { Device } from "@services/devices/types";
import { MeetingInstance } from "@services/meetings/types";
import { MetaData } from "@services/monitoring/types";
import { MonitoredRoom } from "@services/rooms/types";
import React, { createContext } from "react";

export interface IListContext {
  category: string;
  setCategory: (value: string) => void;
  openLocation: boolean;
  setOpenLocation: (value: boolean) => void;
  openFilters: boolean;
  setOpenFilters: (value: boolean) => void;
}

export interface IDetailContext {
  loading: boolean;
  openInfo?: boolean;
  setOpenInfo?: (value: boolean) => void;
  refetch: () => void;
  isPaused: boolean;
  detailFrameRef: React.RefObject<HTMLDivElement | null>;
  room?: MonitoredRoom;
  device?: Device;
  deviceModelInfo?: DeviceModelDetail;
  meeting?: MeetingInstance;
  setOpenAccordion: (name: string) => void;
  openAccordion: string;
  account?: Account;
  accountCanViewPassword?: Boolean;
  favoritesList?: IRoomControl[];
  favoritesControlsList?: IRoomControl[];
  favoritesWorkflowsList?: IRoomControl[];
  resetDevice: () => void;
  deviceGraphMetaData?: MetaData[];
  polling?: {
    start: () => void;
    stop: () => void;
    isPolling: boolean;
  };
}
interface IContextType {
  openNavigation: boolean;
  setOpenNavigation: (value: boolean) => void;
  detail?: IDetailContext;
  canEdit?: boolean;
  showProvisionedOnly?: boolean;
  setShowProvisionedOnly?: (value: boolean) => void;
}

export const RoomsRealtimeContext = createContext<IContextType>({
  openNavigation: false,
  setOpenNavigation: (value: boolean) => {},
});
